export enum PaymentEndpoints {
    PostPaymentProcess = '/v1/payment/process',
    PostPaymentProcessMicroPayment = '/v1/payment/process-micro',
}
